/** ZiniHub layout shell specs. */
export const SHELLS = {
  AppShell: {
    who: "Admin (merchant)",
    sidebar: { width: "160px expanded / 56px icon-only", items: ["Dashboard", "My Hub", "Media Gallery", "Pocket Diary", "Staff Manage...", "Subscription", "Hub Settings", "Log", "Logout (red)"] },
    topbar: { left: ["Collapse toggle (hamburger)", "Breadcrumb: User › Page"], right: ["Dark/light toggle", "Notification bell", "Hub switcher dropdown", "User avatar → menu"] },
    footer: "MyHub©2026 Created by ZiniZ — 40px, border-top, centered",
    note: "Auth pages NOT in sidebar. Edit Biz and Hub Setup are contextual (card action / first-run modal).",
  },
  CustShell: {
    who: "Customer (logged out + logged in)",
    sidebar: { width: "200px expanded with label / 56px icon-only collapsed", items: ["MyHub (logo+collapse)", "Discover", "Orders", "Orders for this Biz (contextual — only inside hub subdomain)", "Profile"] },
    topbar: {
      loggedOut: ["MyHub logo", "Stores link", "Dark toggle", "Cart icon (opens right drawer)", "Login", "Register"],
      loggedIn: ["MyHub logo", "Stores link", "Dark toggle", "Cart icon with badge", "Orders", "Profile", "Logout"],
    },
    cart: "Right-side drawer panel. Opens from cart icon. Shows items grouped by biz + Checkout CTA per biz. Empty state: illustrated + Discover link.",
    footer: "Powered by ZiniHub · ziniz.online",
    note: "Login/Register pages within this shell use minimal header (no Stores link, no cart). Centred card layout.",
  },
  PublicShell: {
    who: "Admin auth only (login/register/reset from admin domain)",
    layout: "Full-screen split. Left: brand panel (violet gradient, logo, value props, stat). Right: form area.",
    leftPanel: "ZiniHub logo + 'Your businesses, one hub.' + 3 value prop chips + social proof stat + footer",
    rightPanel: "Form card vertically centred. Logo top-left on mobile only.",
    footer: "MyHub©2026 Created by ZiniZ",
    note: "Used on admin domain (test-zinihub.ziniz.online). Customer auth uses CustShell-minimal (50-50 split layout, same as admin).",
  },
};

/** Shell subset + preview screen id per app. */
export function getShellsForApp(app) {
  if (app === "admin") {
    return {
      shells: { AppShell: SHELLS.AppShell, PublicShell: SHELLS.PublicShell },
      previewScreenByShell: { AppShell: "order-monitoring", PublicShell: "admin-login" },
    };
  }
  return {
    shells: { CustShell: SHELLS.CustShell },
    previewScreenByShell: { CustShell: "hub-storefront" },
  };
}
